const STORAGE_KEY = "eva_login_performance";

let run;

const readRun = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    return null;
  }
};

const saveRun = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(run));
  } catch {
    // Performance logging must never affect authentication.
  }
};

const elapsed = () => Math.max(0, Date.now() - run.startedAt);
const activityName = (step) => step.replace(/ (started|completed)$/, "");

const logCompletedActivity = (step, startedAt, endedAt, outcome) => {
  const totalMs = Math.max(0, endedAt - startedAt);
  const outcomeSuffix = outcome ? ` (${outcome})` : "";
  console.debug(`[login perf] ${step}${outcomeSuffix}: ${totalMs}ms`);
};

export const startLoginPerformance = () => {
  if (run) return;

  const savedRun = readRun();
  if (savedRun?.awaitingRedirect && typeof savedRun.startedAt === "number") {
    run = {
      ...savedRun,
      steps: Array.isArray(savedRun.steps) ? savedRun.steps : [],
      activities: savedRun.activities || {},
      lastCompletedAt: savedRun.lastCompletedAt || savedRun.startedAt,
      awaitingRedirect: false,
      completed: false,
    };
  } else {
    run = {
      startedAt: Date.now(),
      steps: [],
      activities: {},
      lastCompletedAt: Date.now(),
      completed: false,
      awaitingRedirect: false,
    };
  }
  saveRun();
};

export const markLoginPerformance = (step, outcome = "") => {
  startLoginPerformance();
  if (run.completed) return;

  const now = Date.now();
  const activity = activityName(step);
  if (step.endsWith(" started")) {
    run.activities[activity] = now;
  } else if (step.endsWith(" completed")) {
    const startedAt = run.activities[activity];
    if (!startedAt) return;
    logCompletedActivity(step, startedAt, now, outcome);
    delete run.activities[activity];
    run.lastCompletedAt = now;
  } else {
    return;
  }
  run.steps.push({ step, totalMs: elapsed() });
  saveRun();
};

export const markLoginRedirect = () => {
  startLoginPerformance();
  run.awaitingRedirect = true;
  markLoginPerformance("interactive authentication redirect started");
  saveRun();
};

export const completeLoginPerformance = (outcome) => {
  startLoginPerformance();
  if (run.completed) return;

  const endedAt = Date.now();
  const totalMs = Math.max(0, endedAt - run.startedAt);
  logCompletedActivity(outcome, run.lastCompletedAt || run.startedAt, endedAt);
  run.completed = true;
  run.awaitingRedirect = false;
  console.debug(`[login perf] total login startup time: ${totalMs}ms`);

  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Performance logging must never affect authentication.
  }
};